import { createTheme } from '@mui/material';
import { createBreakpoints } from '@mui/system';

export const spacing = 10;
const baseTheme = createTheme({ spacing });

export const radii = {
  small: baseTheme.spacing(1 / 2),
  medium: baseTheme.spacing(1),
  large: baseTheme.spacing(2),
  xlarge: baseTheme.spacing(4),
};

export const heights = {
  BottomAppBar: 54,
  MobileAppBar: 80,
  DesktopAppBar: 70,
};

export const breakpoints = createBreakpoints({
  values: {
    ...baseTheme.breakpoints.values,
    md: 1025, // from 960, in order to keep iPad Pro as mobile
    narrow: 784,
    modal: 398,
    wideModal: 630,
  },
});

export const theme = createTheme({ spacing, breakpoints });
